import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Helper to get env vars safely in both Vite and Node
const getEnv = (key) => {
    // Vite (Client)
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
        return import.meta.env[key];
    }
    // Node.js (Scripts)
    if (typeof process !== 'undefined' && process.env && process.env[key]) {
        return process.env[key];
    }
    // Fallback or Error
    console.warn(`Missing env var: ${key}`);
    return undefined;
};

const firebaseConfig = {
    apiKey: getEnv("VITE_FIREBASE_API_KEY"),
    authDomain: getEnv("VITE_FIREBASE_AUTH_DOMAIN"),
    projectId: getEnv("VITE_FIREBASE_PROJECT_ID"),
    storageBucket: getEnv("VITE_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: getEnv("VITE_FIREBASE_MESSAGING_SENDER_ID"),
    appId: getEnv("VITE_FIREBASE_APP_ID"),
    measurementId: getEnv("VITE_FIREBASE_MEASUREMENT_ID")
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore & Persistence
const db = getFirestore(app);

// Firestore persistence is enabled by default in Firebase v10+


// Initialize App Check
let appCheck;
try {
    // Enable debug mode for local development if needed
    if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    const recaptchaKey = getEnv('VITE_RECAPTCHA_SITE_KEY');
    appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(recaptchaKey),
        isTokenAutoRefreshEnabled: true
    });
} catch (e) {
    console.warn("App Check failed to initialize:", e);
}

const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, firebaseConfig };
